// @i18n-ignore
export const SITE_DATA_SLUG = 'SITEDATA'

export enum BUILD_ENVIRONMENTS {
  PROD = 'production',
  STAGE = 'staging',
  QA = 'qa',
  DEV = 'dev',
  AUTO_PREVIEW = 'auto-preview',
  FEATURE_PREVIEW = 'feature-preview',
}

export const EMPTY_ARROW_FUNC = () => {
  // do nothing
}

export const EMPTY_ASYNC_ARROW_FUNC = async () => {
  // do nothing
}

export const API_IDME_CALLBACK_PAGE_URI = '/idme/callback'
export const INCLUDE_NON_LIVE_PRODUCTS = false
export const DEFAULT_NEXT_CACHE_DURATION = 0

export const AB_PLATFORM_SSR = 'platform-ab_ssr'
export const AB_PLATFORM_IGNORE = 'platform-ab_ignore'

export const EVENT_DELAY = 1000

// DS overlay tier (modals/sheets/drawers above page chrome); shared with panda.config.ts's popover rule.
export const DS_ELEVATED_OVERLAY_Z_INDEX = 1000
